import React from 'react';

export default function PlayIcon(props) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 44 44" version="1.1" {...props} className="controls__icon--play">
      <path d="M22,41C32.493,41 41,32.493 41,22C41,11.507 32.493,3 22,3C11.507,3 3,11.507 3,22C3,32.493 11.507,41 22,41ZM22,44C9.85,44 0,34.15 0,22C0,9.85 9.85,0 22,0C34.15,0 44,9.85 44,22C44,34.15 34.15,44 22,44Z" />
      <g transform="matrix(6.12323e-17,1,-1,6.12323e-17,47.526,1.72518)">
        <path d="M20.275,15.801L28,31.251L12.55,31.251L20.275,15.801Z" />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/vectors/PlayIcon.js